export const MAPBOX_TOKEN = 'pk.eyJ1Ijoid2lqY2twcmludHMiLCJhIjoiY2tlY3Y0MnV1MG1oYzMwcDc5ZjNyZ242NyJ9.IG8t'
  + 'DQMmJHnL28AvpTCHAw';
export const GET_PLACE_API = 'https://api.mapbox.com/geocoding/v5/mapbox.places';
export const MAP_STYLE_WIJCK = 'mapbox://styles/wijckprints/ckeieem5t4p4k19lzplaakzsm';
export const GET_IMAGE_FROM_API = 'https://api.mapbox.com/styles/v1/wijckprints';
